import React from "react";
import { Container } from "semantic-ui-react";
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import { source } from 'react-aim';
import UserListView from '../drive/TeamsView/UserListView';
import UserGridView from '../drive/TeamsView/UserGridView';
import BreadCrumbOrganization from "../drive/cards/BreadCrumbOrganization";
@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name);
    }
})

class UsersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        dispatch.organizationTab.getCurrentOrganizationData(this.props.selectedOrganisation.id)
    }

    componentWillMount() {
        dispatch.organizationUnit.showDeleteDisabled(false);

        
    }


    render() {
        return (
            <Container fluid >
                <BreadCrumbOrganization {...this.props} />
                {this.props.teamsListViewFlag ?
                    <UserListView usersList={this.props.usersList}
                        {...this.props}
                        name="Community Participant List" />
                    : <UserGridView usersList={this.props.usersList}
                        {...this.props}
                        name="Community Participant List" />
                }

            </Container>
        );
    }
}


export default withRouter(UsersList)

